import React from 'react';
import { Box } from '@mui/material';
import TestCaseDetailsComponent from './TestCaseDetailsComponent';
import TestExecutionForm from './TestExecutionForm';
import UpdateTestScriptsAlert from './UpdateTestScriptsAlert';
import TestStepsComponent from './test-steps/TestScriptsComponent';
import Comments from '../../../elements/common/comments/Comments';
import LinkedIssue from '../../../../features/traceability/LinkedIssue';
import Attachments from '../../../../features/attachments/Attachments';
import { useLocation, useParams } from 'react-router-dom';
import FailuresAnalysis from './FailuresAnalysis';
import { isExecutiveManager } from '../../../../lib/userUtils';
import { getTestCycleKeyFromLocation } from '../../../../lib/executionUtils';
import DetailsCard from '../../../../ui/layout/DetailsCard';

const entityType = 'Execution';

const TestExecutionAccordionBody = ({
  execution,
  data,
  users,
  fetchSelectedExecutionDetails,
  elapsedTime,
  isTestCycleCompleted,
  loading,
  labels,
}) => {
  const { projectId } = useParams();
  const location = useLocation();
  const testCycleKey = getTestCycleKeyFromLocation(location);

  return (
    <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: 1.5 }}>
      <DetailsCard title="Execution">
        <TestExecutionForm
          execution={execution}
          users={users}
          elapsedTime={elapsedTime}
          loading={loading}
        />
      </DetailsCard>

      <DetailsCard title="Test Case Details">
        <TestCaseDetailsComponent testCase={data} projectId={projectId} labels={labels} />
      </DetailsCard>

      {!isExecutiveManager() && (
        <UpdateTestScriptsAlert
          execution={execution}
          data={data}
          fetchSelectedExecutionDetails={fetchSelectedExecutionDetails}
        />
      )}

      <TestStepsComponent
        data={data}
        execution={execution}
        isTestCycleCompleted={isTestCycleCompleted}
        fetchSelectedExecutionDetails={fetchSelectedExecutionDetails}
        projectId={projectId}
      />

      {execution && execution?.status?.name === 'Fail' && (
        <FailuresAnalysis
          executionId={execution?.id}
          testCaseId={execution?.association?.test_case_id}
        />
      )}

      <LinkedIssue
        entityId={execution?.id}
        entityKey={execution?.key}
        entityType={entityType}
        isShowSuggestion={execution?.status?.name === 'Fail'}
        data={data}
        showWarning={execution?.status?.name === 'Fail' ? true : false}
      />

      <Attachments users={users} entityType={entityType} entityId={execution?.id} />

      <Comments
        entityId={execution?.id}
        otherData={{ testCaseKey: data?.key, testCycleKey: testCycleKey }}
        entityType={entityType}
        users={users}
        entityKey={execution?.key}
        isEditable={execution?.is_editable ? true : false}
      />
    </Box>
  );
};

export default TestExecutionAccordionBody;